import * as React from "react";
import { Shield, Check, Cookie, CircleAlert as AlertCircle } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const rightsList = ["Access your personal information", "Request correction of inaccurate information", "Request deletion of your information", "Restrict processing", "Object to processing", "Request transfer of your data", "Withdraw consent where processing is based on consent"];
export default function UserRightsAndPolicies() {
  return <section id="userrightsandpolicies" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4">
            User Rights & Policies
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto">
            Important information regarding your data rights, our use of cookies, and how to raise concerns.
          </p>
        </div>

        <div className="space-y-8">
          {}
          <Card className="shadow-md">
            <CardHeader>
              <CardTitle className="font-default text-2xl flex items-center gap-3 text-primary">
                <Shield className="size-6" />
                Your Rights
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="mb-6 font-sans text-foreground">
                Under UK data protection law, you have the right to:
              </p>
              <ul className="grid gap-4 sm:grid-cols-2">
                {rightsList.map((right, i) => <li key={i} data-index={i} className="flex items-start gap-3 font-sans text-foreground">
                    <Check className="size-5 text-primary shrink-0 mt-0.5" />
                    <span className="leading-tight">{right}</span>
                  </li>)}
              </ul>
              <p className="mt-8 font-sans text-muted-foreground text-sm border-t pt-4">
                To exercise any of these rights, please contact us using the details provided in our full Privacy Policy.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="shadow-md">
            <CardHeader>
              <CardTitle className="font-default text-2xl flex items-center gap-3 text-primary">
                <Cookie className="size-6" />
                Cookies
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 font-sans text-foreground">
              <p>
                Our website may use cookies to improve user experience and analyse website traffic. You can control cookies through your browser settings.
              </p>
              <p>
                Where legally required, we will obtain your consent before placing non-essential cookies on your device.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="shadow-md">
            <CardHeader>
              <CardTitle className="font-default text-2xl flex items-center gap-3 text-primary">
                <AlertCircle className="size-6" />
                Complaints
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 font-sans text-foreground">
              <p>
                If you have concerns about how we handle your personal information, please contact us first so we can try to resolve the matter.
              </p>
              <p>
                You also have the right to lodge a complaint with the Information Commissioner's Office (ICO).
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}